var map = {
	"./abilities.svg": "74f9",
	"./alex.svg": "ad61",
	"./alfred.svg": "9fcb",
	"./career-lab.svg": "45d8",
	"./coach.svg": "f255",
	"./comm-server.svg": "4f68",
	"./hibob.svg": "f7c9",
	"./journey.svg": "aa01",
	"./market.svg": "3344",
	"./resume-editor.svg": "7d96",
	"./resume-parser.svg": "f31d",
	"./videowiki-cast.svg": "afbc",
	"./videowiki-room.svg": "dbc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb83";